<template>
  <svg
    width="240"
    height="240"
    viewBox="0 0 240 240"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M118.188 35.3335C98.3269 35.3335 80.0719 42.2183 65.6577 53.7372H42.3615C39.3349 53.7372 36.8585 56.2217 36.8585 59.2583C36.8585 62.2949 39.3349 64.7794 42.3615 64.7794H54.2176H57.6919C60.7185 64.7794 63.1949 67.2639 63.1949 70.3005C63.1949 71.8169 62.5749 73.2009 61.577 74.1984C60.5828 75.1995 59.2034 75.8216 57.6919 75.8216H50.2797H46.1869H26.2193C23.1927 75.8216 20.7163 78.3061 20.7163 81.3427C20.7163 84.3793 23.1927 86.8638 26.2193 86.8638H40.514C36.1989 97.0381 33.8087 108.233 33.8087 119.99C33.8087 124.256 34.1242 128.449 34.7296 132.545C34.9827 134.257 35.2872 135.954 35.6431 137.632C46.0254 136.038 57.0388 134.757 68.5365 133.823L69.4023 134.614L70.2167 133.69C84.0293 132.612 98.528 132.037 113.482 132.037C145.252 132.037 174.983 134.629 200.404 139.134C201.383 134.872 202.044 130.488 202.355 126.005C202.498 124.017 202.568 122.011 202.568 119.99C202.568 73.234 164.792 35.3335 118.188 35.3335Z"
      fill="#F1F2F7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.50947 75.5654H6.1745C3.10858 75.5654 0.600098 78.1001 0.600098 81.198C0.600098 84.2959 3.10858 86.8306 6.1745 86.8306H9.50947C12.5754 86.8306 15.0839 84.2959 15.0839 81.198C15.0839 78.1001 12.5754 75.5654 9.50947 75.5654Z"
      fill="#F1F2F7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M200.154 187.413C197.056 187.413 194.522 184.878 194.522 181.78C194.522 178.682 197.056 176.147 200.154 176.147C203.252 176.147 205.787 178.682 205.787 181.78C205.787 184.878 203.252 187.413 200.154 187.413Z"
      fill="#E1E3EF"
    />
    <mask
      id="mask0_17042_1220"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="35"
      y="132"
      width="183"
      height="73"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M217.8 132.159V204.311H126.664H35.5283V132.159H217.8Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_17042_1220)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M217.8 160.055C217.8 163.072 215.324 165.541 212.298 165.541H177.156C175.645 165.541 174.267 166.159 173.273 167.154C172.275 168.145 171.655 169.52 171.655 171.027C171.655 174.045 174.131 176.513 177.156 176.513H183.685C185.196 176.513 186.576 177.132 187.57 178.126C188.567 179.118 189.187 180.493 189.187 182C189.187 185.017 186.711 187.486 183.685 187.486H168.673C154.57 198.049 137.046 204.311 118.054 204.311C77.4916 204.311 43.6158 175.764 35.5283 137.718C45.9082 136.134 56.9189 134.862 68.4138 133.933L69.2791 134.719L70.0937 133.801C83.9026 132.729 98.3981 132.159 113.348 132.159C145.111 132.159 174.835 134.734 200.249 139.21C199.013 144.543 197.267 149.678 195.067 154.568H212.298C213.813 154.568 215.185 155.186 216.182 156.181C217.18 157.172 217.8 158.548 217.8 160.055Z"
        fill="#E8EBF2"
      />
    </g>
    <mask
      id="mask1_17042_1220"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="33"
      y="34"
      width="170"
      height="170"
    >
      <ellipse
        cx="117.773"
        cy="118.843"
        rx="84.4395"
        ry="84.8435"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_17042_1220)">
      <g clip-path="url(#clip0_17042_1220)">
        <path
          d="M112.644 59.3335H76.2449V172.475H112.644V59.3335Z"
          fill="url(#paint0_linear_17042_1220)"
        />
        <path
          d="M84.0106 64.8369H80.6504V68.192H84.0106V64.8369Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0934 64.8369H88.7332V68.192H92.0934V64.8369Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.166 64.8369H96.8062V68.192H100.166V64.8369Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 64.8369H104.889V68.192H108.249V64.8369Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 73.4702H80.6504V76.8253H84.0106V73.4702Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0937 73.4702H88.7334V76.8253H92.0937V73.4702Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.167 73.4702H96.8064V76.8253H100.167V73.4702Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 73.4702H104.889V76.8253H108.249V73.4702Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 82.103H80.6504V85.4581H84.0106V82.103Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0937 82.103H88.7334V85.4581H92.0937V82.103Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.167 82.103H96.8064V85.4581H100.167V82.103Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 82.103H104.889V85.4581H108.249V82.103Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 90.7466H80.6504V94.1017H84.0106V90.7466Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0937 90.7466H88.7334V94.1017H92.0937V90.7466Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.167 90.7466H96.8064V94.1017H100.167V90.7466Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 90.7466H104.889V94.1017H108.249V90.7466Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 99.3799H80.6504V102.735H84.0106V99.3799Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0937 99.3799H88.7334V102.735H92.0937V99.3799Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.167 99.3799H96.8064V102.735H100.167V99.3799Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 99.3799H104.889V102.735H108.249V99.3799Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 108.013H80.6504V111.368H84.0106V108.013Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0937 108.013H88.7334V111.368H92.0937V108.013Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.167 108.013H96.8064V111.368H100.167V108.013Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 108.013H104.889V111.368H108.249V108.013Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 116.656H80.6504V120.011H84.0106V116.656Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0937 116.656H88.7334V120.011H92.0937V116.656Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.167 116.656H96.8064V120.011H100.167V116.656Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 116.656H104.889V120.011H108.249V116.656Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 125.29H80.6504V128.645H84.0106V125.29Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0937 125.29H88.7334V128.645H92.0937V125.29Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.167 125.29H96.8064V128.645H100.167V125.29Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 125.29H104.889V128.645H108.249V125.29Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 133.923H80.6504V137.278H84.0106V133.923Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0934 133.923H88.7332V137.278H92.0934V133.923Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.166 133.923H96.8062V137.278H100.166V133.923Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 133.923H104.889V137.278H108.249V133.923Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0106 142.566H80.6504V145.921H84.0106V142.566Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0937 142.566H88.7334V145.921H92.0937V142.566Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.167 142.566H96.8064V145.921H100.167V142.566Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 142.566H104.889V145.921H108.249V142.566Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0104 151.199H80.6501V154.554H84.0104V151.199Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0934 151.199H88.7332V154.554H92.0934V151.199Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.166 151.199H96.8062V154.554H100.166V151.199Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 151.199H104.889V154.554H108.249V151.199Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.0104 159.833H80.6501V163.188H84.0104V159.833Z"
          fill="#C5CAE4"
        />
        <path
          d="M92.0934 159.833H88.7332V163.188H92.0934V159.833Z"
          fill="#C5CAE4"
        />
        <path
          d="M100.166 159.833H96.8062V163.188H100.166V159.833Z"
          fill="#C5CAE4"
        />
        <path
          d="M108.249 159.833H104.889V163.188H108.249V159.833Z"
          fill="#C5CAE4"
        />
        <path
          d="M182.667 79.106H137.109V247.085H182.667V79.106Z"
          fill="#D8DBEA"
        />
        <path
          d="M146.831 85.9902H142.621V90.1943H146.831V85.9902Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 85.9902H152.722V90.1943H156.932V85.9902Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 85.9902H162.833V90.1943H167.044V85.9902Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 85.9902H172.945V90.1943H177.155V85.9902Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 96.8018H142.621V101.006H146.831V96.8018Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 96.8018H152.722V101.006H156.932V96.8018Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 96.8018H162.833V101.006H167.044V96.8018Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 96.8018H172.945V101.006H177.155V96.8018Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 107.604H142.621V111.808H146.831V107.604Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 107.604H152.722V111.808H156.932V107.604Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 107.604H162.833V111.808H167.044V107.604Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 107.604H172.945V111.808H177.155V107.604Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 118.416H142.621V122.62H146.831V118.416Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 118.416H152.722V122.62H156.932V118.416Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 118.416H162.833V122.62H167.044V118.416Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 118.416H172.945V122.62H177.155V118.416Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 129.217H142.621V133.421H146.831V129.217Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 129.217H152.722V133.421H156.932V129.217Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 129.217H162.833V133.421H167.044V129.217Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 129.217H172.945V133.421H177.155V129.217Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 140.029H142.621V144.233H146.831V140.029Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 140.029H152.722V144.233H156.932V140.029Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 140.029H162.833V144.233H167.044V140.029Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 140.029H172.945V144.233H177.155V140.029Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 150.841H142.621V155.045H146.831V150.841Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 150.841H152.722V155.045H156.932V150.841Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 150.841H162.833V155.045H167.044V150.841Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 150.841H172.945V155.045H177.155V150.841Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 161.643H142.621V165.847H146.831V161.643Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 161.643H152.722V165.847H156.932V161.643Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 161.643H162.833V165.847H167.044V161.643Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 161.643H172.945V165.847H177.155V161.643Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 172.455H142.621V176.659H146.831V172.455Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 172.455H152.722V176.659H156.932V172.455Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 172.455H162.833V176.659H167.044V172.455Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 172.455H172.945V176.659H177.155V172.455Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 183.257H142.621V187.461H146.831V183.257Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 183.256H152.722V187.46H156.932V183.256Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 183.256H162.833V187.46H167.044V183.256Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 183.256H172.945V187.46H177.155V183.256Z"
          fill="#C5CAE4"
        />
        <path
          d="M146.831 194.069H142.621V198.273H146.831V194.069Z"
          fill="#C5CAE4"
        />
        <path
          d="M156.932 194.069H152.722V198.273H156.932V194.069Z"
          fill="#C5CAE4"
        />
        <path
          d="M167.044 194.069H162.833V198.273H167.044V194.069Z"
          fill="#C5CAE4"
        />
        <path
          d="M177.155 194.069H172.945V198.273H177.155V194.069Z"
          fill="#C5CAE4"
        />
        <path
          d="M130.983 123.049H96.4478V230.381H130.983V123.049Z"
          fill="#D8DBEA"
        />
        <path
          d="M103.824 128.266H100.627V131.458H103.824V128.266Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 128.266H108.29V131.458H111.487V128.266Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 128.266H115.954V131.458H119.15V128.266Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 128.266H123.616V131.458H126.813V128.266Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 136.459H100.627V139.651H103.824V136.459Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 136.459H108.29V139.651H111.487V136.459Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 136.459H115.953V139.651H119.15V136.459Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 136.459H123.616V139.651H126.813V136.459Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 144.653H100.628V147.845H103.824V144.653Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 144.653H108.291V147.844H111.487V144.653Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 144.653H115.954V147.844H119.15V144.653Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 144.653H123.616V147.844H126.813V144.653Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 152.846H100.627V156.038H103.824V152.846Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 152.846H108.29V156.038H111.487V152.846Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 152.846H115.953V156.038H119.15V152.846Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 152.846H123.616V156.038H126.813V152.846Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 161.04H100.628V164.231H103.824V161.04Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 161.04H108.291V164.231H111.487V161.04Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 161.04H115.954V164.231H119.15V161.04Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 161.04H123.616V164.231H126.813V161.04Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 169.233H100.627V172.424H103.824V169.233Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 169.233H108.29V172.424H111.487V169.233Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 169.233H115.953V172.424H119.15V169.233Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 169.233H123.616V172.424H126.813V169.233Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 177.426H100.628V180.618H103.824V177.426Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 177.426H108.291V180.618H111.487V177.426Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 177.426H115.954V180.618H119.15V177.426Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 177.426H123.616V180.618H126.813V177.426Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 185.62H100.627V188.811H103.824V185.62Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 185.62H108.29V188.811H111.487V185.62Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 185.62H115.953V188.811H119.15V185.62Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 185.62H123.616V188.811H126.813V185.62Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 193.813H100.628V197.004H103.824V193.813Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 193.813H108.291V197.004H111.487V193.813Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 193.813H115.954V197.004H119.15V193.813Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 193.813H123.616V197.004H126.813V193.813Z"
          fill="#C5CAE4"
        />
        <path
          d="M103.824 202.006H100.628V205.198H103.824V202.006Z"
          fill="#C5CAE4"
        />
        <path
          d="M111.487 202.006H108.291V205.198H111.487V202.006Z"
          fill="#C5CAE4"
        />
        <path
          d="M119.15 202.006H115.954V205.198H119.15V202.006Z"
          fill="#C5CAE4"
        />
        <path
          d="M126.813 202.006H123.616V205.198H126.813V202.006Z"
          fill="#C5CAE4"
        />
        <path
          d="M88.672 152.59H57.3335V250H88.672V152.59Z"
          fill="#D8DBEA"
        />
        <path
          d="M64.0233 157.326H61.124V160.221H64.0233V157.326Z"
          fill="#C5CAE4"
        />
        <path
          d="M70.9793 157.326H68.0801V160.221H70.9793V157.326Z"
          fill="#C5CAE4"
        />
        <path
          d="M77.9354 157.326H75.0361V160.221H77.9354V157.326Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.8919 157.326H81.9927V160.221H84.8919V157.326Z"
          fill="#C5CAE4"
        />
        <path
          d="M64.0238 164.752H61.1245V167.647H64.0238V164.752Z"
          fill="#C5CAE4"
        />
        <path
          d="M70.9798 164.752H68.0806V167.647H70.9798V164.752Z"
          fill="#C5CAE4"
        />
        <path
          d="M77.9354 164.752H75.0361V167.647H77.9354V164.752Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.8922 164.752H81.9929V167.647H84.8922V164.752Z"
          fill="#C5CAE4"
        />
        <path
          d="M64.0238 172.189H61.1245V175.084H64.0238V172.189Z"
          fill="#C5CAE4"
        />
        <path
          d="M70.9798 172.189H68.0806V175.084H70.9798V172.189Z"
          fill="#C5CAE4"
        />
        <path
          d="M77.9354 172.189H75.0361V175.084H77.9354V172.189Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.8924 172.189H81.9932V175.084H84.8924V172.189Z"
          fill="#C5CAE4"
        />
        <path
          d="M64.0238 179.625H61.1245V182.52H64.0238V179.625Z"
          fill="#C5CAE4"
        />
        <path
          d="M70.9798 179.625H68.0806V182.52H70.9798V179.625Z"
          fill="#C5CAE4"
        />
        <path
          d="M77.9354 179.625H75.0361V182.52H77.9354V179.625Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.8924 179.625H81.9932V182.52H84.8924V179.625Z"
          fill="#C5CAE4"
        />
        <path
          d="M64.0233 187.062H61.124V189.956H64.0233V187.062Z"
          fill="#C5CAE4"
        />
        <path
          d="M70.9793 187.062H68.0801V189.956H70.9793V187.062Z"
          fill="#C5CAE4"
        />
        <path
          d="M77.9354 187.062H75.0361V189.956H77.9354V187.062Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.8919 187.062H81.9927V189.956H84.8919V187.062Z"
          fill="#C5CAE4"
        />
        <path
          d="M64.0238 194.499H61.1245V197.393H64.0238V194.499Z"
          fill="#C5CAE4"
        />
        <path
          d="M70.9798 194.499H68.0806V197.393H70.9798V194.499Z"
          fill="#C5CAE4"
        />
        <path
          d="M77.9354 194.499H75.0361V197.393H77.9354V194.499Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.8924 194.499H81.9932V197.393H84.8924V194.499Z"
          fill="#C5CAE4"
        />
        <path
          d="M64.0238 201.935H61.1245V204.829H64.0238V201.935Z"
          fill="#C5CAE4"
        />
        <path
          d="M70.9798 201.935H68.0806V204.829H70.9798V201.935Z"
          fill="#C5CAE4"
        />
        <path
          d="M77.9354 201.935H75.0361V204.829H77.9354V201.935Z"
          fill="#C5CAE4"
        />
        <path
          d="M84.8924 201.935H81.9932V204.829H84.8924V201.935Z"
          fill="#C5CAE4"
        />
      </g>
      <g clip-path="url(#clip1_17042_1220)">
        <path
          d="M155.336 93.2064L104.888 132.251L80.405 136.368L34.2808 147.695C27.0708 149.47 25.045 158.76 30.8718 163.357L50.1274 178.572L61.7375 171.547H61.7266L53.7433 160.165L73.7831 156.07L61.3236 191.292L106.969 196.542L120.975 145.724L168.798 105.143L155.336 93.1846V93.2064Z"
          fill="white"
        />
        <path
          d="M53.83 184.104C55.0607 186.021 57.0756 187.36 59.3409 187.567C59.94 187.622 60.5499 187.6 61.1489 187.48C61.9439 187.328 62.6954 186.968 63.3053 186.435L63.7301 186.87L65.7668 188.94C66.1479 189.332 66.6489 189.528 67.1499 189.528C67.6509 189.528 68.1519 189.343 68.544 188.972C69.3173 188.21 69.3282 186.968 68.5658 186.195L65.7232 183.298L65.9519 182.666L70.5698 186.228C71.4302 186.892 72.6609 186.729 73.3252 185.868C73.4995 185.65 73.6084 185.411 73.6738 185.16C73.8807 184.42 73.6302 183.592 72.9767 183.091L70.3084 181.043L68.1955 179.421L70.8094 180.902L73.3361 182.329C74.0114 182.71 74.8173 182.645 75.4272 182.22C75.4926 182.165 75.5688 182.111 75.6342 182.056C75.6777 182.024 75.7213 181.98 75.754 181.937C75.7866 181.904 75.8193 181.86 75.852 181.817C75.8847 181.773 75.9282 181.73 75.9609 181.675C75.9718 181.653 75.9827 181.632 75.9936 181.61C75.9936 181.599 76.0045 181.588 76.0154 181.577C76.0371 181.544 76.048 181.512 76.0589 181.479C76.0916 181.403 76.1352 181.316 76.1678 181.24C76.1787 181.196 76.1896 181.163 76.2005 181.12C76.2223 181.033 76.2441 180.945 76.255 180.847C76.255 180.815 76.255 180.782 76.255 180.749C76.255 180.651 76.255 180.553 76.255 180.466C76.255 180.444 76.255 180.412 76.255 180.379C76.255 180.281 76.2332 180.183 76.2005 180.085C76.2005 180.063 76.1896 180.042 76.1787 180.02C76.1461 179.922 76.1134 179.824 76.0589 179.726C76.0589 179.715 76.048 179.704 76.0371 179.693C75.9827 179.595 75.9282 179.497 75.852 179.399C75.6995 179.203 75.5035 179.029 75.2748 178.887L70.4717 176.175L71.3322 175.62L75.0896 176.437C76.1461 176.665 77.2025 176.001 77.4312 174.944C77.6599 173.888 76.9956 172.842 75.9282 172.603L71.844 171.71C71.1361 171.557 70.3955 171.677 69.7856 172.058L63.839 174.629L61.7152 171.557C61.3667 171.361 58.0885 169.586 54.6142 171.176C51.8369 172.45 50.0508 175.369 50.1052 178.582C51.3359 180.423 52.5775 182.263 53.8082 184.093L53.83 184.104Z"
          fill="#F1F2F7"
        />
        <path
          d="M77.4532 174.955C77.2245 176.011 76.1681 176.676 75.1116 176.447L71.3542 175.619L70.4938 176.175L69.6769 175.739C68.9036 175.336 67.9997 175.227 67.161 175.434L63.7412 176.284L63.861 174.628L69.8076 172.058C70.4284 171.677 71.169 171.557 71.866 171.709L75.9502 172.602C77.0176 172.842 77.6819 173.877 77.4532 174.944V174.955Z"
          fill="#F1F2F7"
        />
        <path
          d="M76.2764 180.466C76.2764 180.466 76.2764 180.412 76.2764 180.39C76.2764 180.292 76.2546 180.194 76.222 180.096C76.222 180.074 76.2111 180.052 76.2002 180.031C76.1675 179.933 76.1348 179.835 76.0804 179.737C76.0804 179.726 76.0804 179.715 76.0586 179.704C76.0042 179.595 75.9497 179.497 75.8735 179.399C75.721 179.203 75.5249 179.029 75.2853 178.887L70.112 175.968C68.6308 175.13 66.8229 175.075 65.2981 175.827L63.3268 176.785L62.9238 178.408L65.8862 178.321C66.3872 178.299 66.8882 178.462 67.2912 178.767L69.4585 180.39L69.6328 180.51L68.2169 179.421L70.8308 180.902L73.3576 182.329C74.0328 182.71 74.8388 182.644 75.4487 182.22C75.5249 182.176 75.5794 182.111 75.6556 182.056C75.6992 182.024 75.7428 181.98 75.7754 181.937C75.8081 181.904 75.8408 181.86 75.8626 181.817C75.9061 181.773 75.9497 181.73 75.9715 181.675C75.9824 181.653 75.9933 181.632 76.0042 181.61C76.0042 181.599 76.015 181.588 76.0259 181.577C76.0477 181.544 76.0586 181.512 76.0695 181.479C76.1022 181.403 76.1457 181.316 76.1784 181.24C76.1893 181.196 76.2002 181.163 76.2111 181.12C76.2329 181.033 76.2547 180.945 76.2655 180.847C76.2655 180.815 76.2655 180.782 76.2655 180.749C76.2655 180.651 76.2764 180.553 76.2655 180.466H76.2764Z"
          fill="#F1F2F7"
        />
        <path
          d="M63.708 181.392L65.7338 183.287"
          stroke="#C7D2EA"
          stroke-width="0.366667"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M62.9351 178.408L65.2549 178.081C65.941 178.027 66.6272 178.223 67.1826 178.637L68.2173 179.41L70.3302 181.033"
          stroke="#C7D2EA"
          stroke-width="0.366667"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M63.8613 174.618L51.3038 180.325C50.9117 179.737 50.5305 179.159 50.1384 178.582C50.084 175.369 51.8701 172.45 54.6474 171.176C58.1217 169.586 61.4108 171.361 61.7484 171.557L63.8722 174.618H63.8613Z"
          fill="#F1F2F7"
        />
        <path
          d="M168.798 105.164C166.696 107.441 162.023 106.537 158.364 103.139C154.705 99.7516 153.452 95.1664 155.554 92.8901C157.656 90.6139 162.328 91.5178 165.988 94.9159C169.647 98.303 170.9 102.888 168.798 105.164Z"
          fill="#ADB0CC"
        />
        <path
          d="M103.418 194.233L41.5018 289.476L18.4561 281.852L66.007 191.608L103.418 194.233Z"
          fill="#0A9378"
        />
        <path
          d="M106.174 263.566L138.717 205.527C146.787 191.129 133.859 174.008 117.805 177.842L61.3237 191.303C48.8097 202.641 59.69 223.182 76.1031 219.195L103.897 210.624L85.2952 254.886L106.174 263.566Z"
          fill="#ADB0CC"
        />
        <path
          d="M106.968 121.316L103.135 140.953L90.1523 137.391C90.7187 136.4 92.4395 130.878 92.8534 129.691C93.8445 126.903 94.0514 124.355 94.0296 122.427L106.968 121.316Z"
          fill="#F1F2F7"
        />
        <path
          d="M107.339 112.81C110.41 117.079 109.234 122.666 104.964 125.749C100.695 128.82 94.9661 128.221 91.8948 123.952C91.7641 123.766 91.6334 123.581 91.5245 123.396C91.1869 122.862 90.9146 122.307 90.7077 121.73C90.6641 121.621 90.6205 121.512 90.5879 121.392C89.3027 117.548 90.5879 113.148 94.0513 110.653C94.0948 110.621 94.1384 110.588 94.1819 110.555C94.4978 110.338 94.8136 110.142 95.1404 109.967C97.9503 108.464 101.272 108.508 104.006 109.913C104.376 110.098 104.736 110.316 105.073 110.555C105.759 111.035 106.402 111.612 106.957 112.287C107.099 112.451 107.23 112.625 107.349 112.799L107.339 112.81Z"
          fill="#F1F2F7"
        />
        <path
          d="M97.8307 109.76C98.506 109.532 99.4862 109.292 100.695 109.303C102.514 109.325 103.908 109.913 104.649 110.294L103.984 109.368C102.449 107.233 99.4644 106.754 97.3297 108.29L96.6436 108.78L97.8307 109.76Z"
          fill="#ADB0CC"
        />
        <path
          d="M99.3553 120.858L99.0504 117.798L97.286 115.293C98.3534 113.539 98.7672 111.862 98.9306 110.838C99.0177 110.261 98.8761 109.662 98.5385 109.183C97.8197 108.181 96.4256 107.963 95.4345 108.704L93.6157 110.054L93.5939 110.032L89.0305 113.321C88.7582 113.517 88.4968 113.735 88.2572 113.964C84.5869 117.035 84.5651 122.688 88.2246 125.781L92.8424 129.68C96.9484 128.841 99.7583 125.029 99.3553 120.847V120.858Z"
          fill="#ADB0CC"
        />
        <path
          d="M100.64 117.254C101.283 118.136 101.37 120.292 101.337 121.872C101.316 122.852 100.368 123.538 99.4314 123.244C97.9175 122.776 95.9027 122.002 95.271 121.12C94.2036 119.639 94.5413 117.57 96.0225 116.502C97.5037 115.435 99.573 115.772 100.64 117.254Z"
          fill="#F1F2F7"
        />
        <path
          d="M96.1145 113.734L97.7053 112.588L99.5384 115.134C100.149 115.982 99.9565 117.168 99.108 117.779L99.055 117.817L96.1145 113.734Z"
          fill="#ADB0CC"
        />
        <path
          d="M105.672 111.524H109.092C109.528 111.524 109.778 112.015 109.528 112.374L107.807 114.814L105.672 111.535V111.524Z"
          fill="#F1F2F7"
        />
        <path
          d="M108.319 114.084L109.419 115.631C111.009 117.874 110.617 120.967 108.515 122.742L104.964 125.748L108.329 114.084H108.319Z"
          fill="#F1F2F7"
        />
        <path
          d="M168.21 85.0916C168.319 85.2877 168.46 85.4619 168.634 85.6144C169.092 86.0174 169.691 86.2134 170.333 86.1699C170.976 86.1263 171.597 85.854 172.054 85.3966L178.404 79.1124C179.123 78.3936 179.34 77.3589 178.927 76.5203C178.807 76.2807 178.654 76.0737 178.447 75.8995C177.511 75.0717 175.975 75.1698 175.017 76.1173L167.611 82.8263C166.892 83.5451 167.73 84.1659 168.144 84.9936C168.166 85.0263 168.177 85.059 168.199 85.0916H168.21Z"
          fill="#F1F2F7"
        />
        <path
          d="M180.451 93.2057L172.446 101.254C171.858 101.842 171.074 102.147 170.279 102.147H170.225C170.083 102.147 169.941 102.147 169.8 102.104C169.538 102.071 169.277 102.006 169.037 101.886L163.897 106.199C162.078 105.796 160.107 104.75 158.364 103.138C155.837 100.797 154.454 97.878 154.541 95.5582L159.312 91.7463V91.67C159.29 91.1908 159.344 90.7007 159.453 90.2433C159.715 89.1324 160.335 88.1195 161.228 87.368L165.716 83.5234L170.192 84.7868L180.451 93.2057Z"
          fill="#F1F2F7"
        />
        <path
          d="M170.715 89.8403C171.27 89.9493 171.826 89.8403 172.294 89.5245L176.955 86.3334C177.402 86.0284 177.707 85.5601 177.816 85.0155C177.914 84.4819 177.805 83.9373 177.489 83.4799C177.184 83.0442 176.737 82.7393 176.215 82.6304C175.659 82.5215 175.104 82.6304 174.635 82.9462L169.974 86.1373C169.212 86.6601 168.885 87.6403 169.201 88.5225C169.255 88.6859 169.342 88.8492 169.44 88.9908C169.745 89.4265 170.192 89.7314 170.715 89.8403Z"
          fill="#F1F2F7"
        />
        <path
          d="M175.507 95.8302C176.062 95.9391 176.618 95.8302 177.086 95.5144L180.462 93.2054C181.399 92.5629 181.628 91.2886 180.996 90.352C180.691 89.9163 180.245 89.6114 179.722 89.5024C179.166 89.3935 178.611 89.5024 178.143 89.8183L174.766 92.1272C174.004 92.65 173.677 93.6302 173.993 94.5124C174.047 94.6758 174.135 94.8391 174.233 94.9807C174.538 95.4164 174.984 95.7213 175.507 95.8302Z"
          fill="#F1F2F7"
        />
        <path
          d="M172.741 93.1616C173.296 93.2705 173.852 93.1616 174.32 92.8458L178.981 89.6547C179.918 89.0121 180.147 87.7378 179.515 86.8012C179.21 86.3655 178.763 86.0606 178.241 85.9517C177.685 85.8427 177.13 85.9517 176.661 86.2675L172 89.4586C171.227 89.9814 170.911 90.9616 171.227 91.8438C171.281 92.0072 171.368 92.1705 171.466 92.3121C171.771 92.7478 172.218 93.0527 172.741 93.1616Z"
          fill="#F1F2F7"
        />
        <path
          d="M166.685 84.1113L171.674 87.1718C171.674 87.1718 173.895 93.249 166.642 96.4184"
          fill="#F1F2F7"
        />
        <path
          d="M167.11 86.6271L170.355 86.7905L170.53 88.4678C170.639 89.5242 171.586 90.2866 172.632 90.1777C173.688 90.0688 174.451 89.1321 174.342 88.0757L174.135 86.1153C173.96 84.3944 172.566 83.0766 170.835 82.9895L167.306 82.8043C166.249 82.7499 165.345 83.5667 165.291 84.6232"
          fill="#F1F2F7"
        />
        <path
          d="M166.652 96.4078C170.584 94.6869 171.728 92.1166 171.945 90.1235"
          stroke="#C7D2EA"
          stroke-width="0.366667"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M167.11 86.6275L170.355 86.7909L170.529 88.4681C170.638 89.5246 171.586 90.2869 172.631 90.178C173.688 90.0691 174.45 89.1325 174.341 88.076L174.134 86.1156C173.96 84.3948 172.566 83.077 170.834 82.9898L167.306 82.8047"
          stroke="#C7D2EA"
          stroke-width="0.366667"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M174.624 82.957L173.111 83.9917"
          stroke="#C7D2EA"
          stroke-width="0.366667"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M174.363 88.1083L176.944 86.333"
          stroke="#C7D2EA"
          stroke-width="0.366667"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M174.047 92.9985C173.829 93.4669 173.808 94.0114 173.982 94.5233C174.047 94.6867 174.123 94.85 174.221 94.9916C174.526 95.4273 174.973 95.7322 175.496 95.8411C176.051 95.9609 176.618 95.8411 177.075 95.5253L180.451 93.2164"
          stroke="#C7D2EA"
          stroke-width="0.366667"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M171.379 92.1818C171.379 92.1818 171.434 92.2689 171.466 92.3125C171.771 92.759 172.218 93.064 172.73 93.162C173.187 93.2491 173.645 93.1947 174.048 92.9877C174.135 92.9442 174.233 92.8897 174.309 92.8353L178.97 89.6441C179.047 89.5897 179.134 89.5243 179.199 89.459"
          stroke="#C7D2EA"
          stroke-width="0.366667"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M92.3089 131.347L91.3832 134.124L100.118 140.125L95.4892 144.025L87.092 135.007C87.5059 134.353 88.3227 133.242 89.7495 132.371C90.7297 131.772 91.6663 131.489 92.3089 131.347Z"
          fill="white"
        />
        <path
          d="M100.129 140.126L104.431 143.709L108.733 132.545C108.493 132.055 107.949 131.13 106.892 130.411C106.315 130.019 105.759 129.812 105.335 129.692C105.182 130.541 105.041 131.402 104.888 132.251L100.129 140.126Z"
          fill="white"
        />
        <path
          d="M114.385 169.117C109.93 168.638 105.563 166.798 102.612 163.4C98.5056 158.684 97.3947 151.191 98.3095 144.95L102.35 144.83C103.058 153.412 105.53 163.029 112.566 167.985C113.154 168.399 113.753 168.78 114.385 169.117Z"
          fill="#D8DBEA"
        />
        <path
          d="M151.687 153.543V162.681C145.85 166.558 139.566 169.989 132.715 171.405C114.254 175.129 104.376 165.207 103.864 164.685C104.333 165.022 111.423 170.152 118.872 168.823C118.894 168.823 118.916 168.812 118.938 168.812C119.232 168.791 119.515 168.758 119.798 168.714C125.407 167.876 134.109 165.382 139.783 157.976C140.317 157.202 140.84 156.44 141.352 155.689L151.687 153.543Z"
          fill="#ADB0CC"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_17042_1220"
        x1="94.4445"
        y1="59.3335"
        x2="94.4445"
        y2="172.475"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D8DBEA" />
        <stop
          offset="1"
          stop-color="#D8DBEA"
        />
      </linearGradient>
      <clipPath id="clip0_17042_1220">
        <rect
          width="125.333"
          height="190.667"
          fill="white"
          transform="translate(57.333 59.333)"
        />
      </clipPath>
      <clipPath id="clip1_17042_1220">
        <rect
          width="173.333"
          height="247.938"
          fill="white"
          transform="translate(8 75.3335)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
